import React from "react";
import privacypolicylogo from "../../Assests/privacypolicylogo.svg";
import privarcypolicylogotwo from "../../Assests/privarcypolicylogotwo.svg";
import { Col, Row } from "antd";

const sections = [
  {
    num: 1,
    title: "Information We Collect",
    lead: "We may collect the following types of information:",
    items: [
      "User Information: Name, email address, company name, and related contact details.",
      "Vehicle Data: Vehicle Identification Number (VIN), license plate number, make, model, and year.",
      "Driver Data: Name, driver's license number, and contact information. (with client consent)",
      "Location Data: Real-time GPS location of vehicles (with consent).",
      "Customer Data: Customer names and contact details (if entered into the App).",
    ],
  },
  {
    num: 2,
    title: "How We Use Your Information",
    lead: "We process collected data for the following purposes:",
    items: [
      "To provide and improve the App and its functionalities.",
      "To track vehicles, optimize deliveries, and enhance operational efficiency.",
      "To generate and deliver periodic reports to clients.",
      "To communicate with you regarding product updates, promotions, and customer support.",
      "To carry out marketing activities related to TrackRight (with consent).",
      "To integrate with third-party services, such as telematics providers, ERP software for TrackRight AI and AI Cargo.",
      "To comply with legal obligations and enforce contractual agreements.",
    ],
  },
  {
    num: 3,
    title: "Legal Basis for Processing",
    lead: "We process your data based on the following legal grounds:",
    items: [
      "Contractual necessity: to provide services under the client contract.",
      "Consent: for location data collection and marketing communications.",
      "Legitimate interests: to improve our services and ensure operational security.",
      "Legal compliance: where required by law.",
    ],
  },
  {
    num: 4,
    title: "Sharing Your Information",
    lead: "We will not share your personal data with third parties except in the following cases:",
    items: [
      "Service Providers: We use trusted partners such as Amazon Web Services (AWS) for data hosting, ERP software for consignments, and telematics providers for telematics integration. These providers are contractually bound to protect your data.",
      "Legal Obligations: We may disclose information if required by law or necessary to protect the rights, safety, or property of TrackRight or others.",
    ],
  },
];

const styles = {
  wrapper: {
    fontFamily: "DM Sans",
    fontSize: 15,
    background: "#fff",
    padding: "32px 48px",
    lineHeight: 1.6,
  },
  section: { marginBottom: 28 },
  heading: { fontSize: 15, fontWeight: "bold", marginBottom: 6 },
  lead: { marginBottom: 8 },
  list: { listStyle: "none", padding: 0, margin: 0 },
  listItem: { paddingLeft: 18, position: "relative", marginBottom: 2 },
  bullet: { position: "absolute", left: 4, top: 0 },
};

export default function PrivacyPolicee() {
  return (
    <>
      <img
        src={privarcypolicylogotwo}
        alt="Privacy Policy"
        style={{ display: "block", margin: "0 auto 24px" }}
      />
      <Row>
        <Col xl={3}></Col>
        <Col xl={15}>
          <div style={styles.wrapper}>
            {sections.map((sec) => (
              <div key={sec.num} style={styles.section}>
                <h2 style={styles.heading}>
                  {sec.num}. {sec.title}
                </h2>
                <p style={styles.lead}>{sec.lead}</p>
                <ul style={styles.list}>
                  {sec.items.map((item, i) => (
                    <li key={i} style={styles.listItem}>
                      <span style={styles.bullet}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Col>
        <Col xl={6}></Col>
      </Row>
    </>
  );
}
